import { DeviceBreakpointsType } from '@kubit/web-ui-components/types/breakpoints';
import { QuickButtonContainerVariantType } from '../../../../../components/quickButtonContainer/types/quickButtonContainer';
export const getQuickButtonContainerStyles = (FOUNDATIONS, FONT) => {
    return {
        [QuickButtonContainerVariantType.DEFAULT]: {
            container: {
                display: 'flex',
                flex_direction: 'column',
                gap: FOUNDATIONS.spacing_300,
            },
            quickButtonsContainer: {
                justify_content: 'center',
                align_items: 'baseline',
                text_align: 'center',
                width: 'fit-content',
                margin: 'auto',
                display: 'grid',
                // same as tagContainer top in quickButtonComplex
                margin_top: '0.813rem',
                [DeviceBreakpointsType.DESKTOP]: {
                    justify_content: 'space-between',
                    gap: FOUNDATIONS.spacing_600,
                },
                [DeviceBreakpointsType.TABLET]: {
                    justify_content: 'space-between',
                    gap: FOUNDATIONS.spacing_400,
                },
                [DeviceBreakpointsType.MOBILE]: {
                    display: 'flex',
                    width: '100%',
                    justify_items: 'center',
                    flex_wrap: 'wrap',
                    gap: FOUNDATIONS.spacing_100,
                },
            },
            listItemContainer: {
                width: FOUNDATIONS.size_600,
                [DeviceBreakpointsType.MOBILE]: {
                    display: 'flex',
                    flex: 1,
                    justify_content: 'center',
                },
            },
            modalListItemContainer: {
                width: FOUNDATIONS.size_600,
            },
            footer: {
                display: 'flex',
                justify_content: 'center',
                [DeviceBreakpointsType.DESKTOP]: {},
                [DeviceBreakpointsType.TABLET]: {
                    padding_bottom: FOUNDATIONS.spacing_250,
                },
                [DeviceBreakpointsType.MOBILE]: {
                    padding_bottom: FOUNDATIONS.spacing_250,
                },
            },
            closeIcon: {
                width: FOUNDATIONS.size_350,
                height: FOUNDATIONS.size_350,
                color: FOUNDATIONS.color_neutral_icon_50,
            },
        },
    };
};
//# sourceMappingURL=styles.js.map